import React, { Component } from 'react';
import { MENUS } from 'Common';
import { connect } from 'react-redux';
import { setSubMenuDirection } from 'actions';
import { VERTICAL, HORIZONTAL } from 'constants';
import Statistics from "./Statistics";


class SubMenu extends Component {
  handleClick = () => this.props.setSubMenuDirection(this.props.subMenuDirection === VERTICAL ? HORIZONTAL : VERTICAL);

  render() {
    const { auth: { loggedAs, currentClient, user, preference, detached }, subMenuDirection, step, application } = this.props;
    const currentMenus = MENUS[loggedAs];

    if (user == null || user.id == null) {
      return null;
    }

    return (
      <nav id="subMenu" className={`sub-menu ${subMenuDirection === VERTICAL ? 'vertical' : ''}`} style={{ zIndex: 9999 }}>
        <span className="flip-menu flex-column-center" onClick={this.handleClick}>
          <img src={"/img/icons/menu_direction.svg"} className="icomoon icon-tt-menu" />
        </span>
          <ul className="menu">
            {(loggedAs === "ADMIN" || (user && (user.type === "ADMIN" ))) ? <Statistics subMenuDirection={this.props.subMenuDirection}/> : null}
          </ul>
      </nav>
    );
  }
}


const mapStateToProps = state => ({
  auth: state.auth,
  subMenuDirection: state.params.subMenuDirection,
});

const mapDispatchToProps = dispatch => ({
  setSubMenuDirection: (direction) => dispatch(setSubMenuDirection(direction))
});
export default connect(mapStateToProps, mapDispatchToProps)(SubMenu);



// WEBPACK FOOTER //
// ./app/components/menu/SubMenu.js